import React, { useState, useEffect, useRef } from 'react';
import CommonInput from '../../components/Dashboard-res/CommonComponent/CommonInput';
import SearchIcon from '../../images/icons/searchIcon.svg';

const MBTableSearchBox = ({
  searchbar,
  setSearchBar,
  containerStyle,
  onEnter,
  inputContainerRef,
  onChangeEvent
}) => {
  return (
    <div>
      <div
        className="flex"
        style={{
          margin: '0 auto 20px',
          width: '92%',
          ...(containerStyle || {})
        }}
      >
        <CommonInput
          name="searchbar"
          id="searchbar"
          inputContainerRef={inputContainerRef}
          onChange={event => {
            setSearchBar(event.target.value);
            if (typeof onChangeEvent == 'function') onChangeEvent();
          }}
          placeholder="Search by name or Lead ID"
          inputStyle={{
            backgroundColor: '#F5F7F9',
            width: '100%',
            height: '100%',
            top: '0px',
            borderRadius: '6px'
          }}
          value={searchbar}
          stylesContainer={{
            height: '40px',
            maxWidth: '100%',
            position: 'relative',
            backgroundColor: '#F5F7F9',
            borderRadius: '6px',
            borderColor: 'transparent',
            background: 'unset'
          }}
          fieldsetStyle={{
            borderRadius: '6px'
          }}
          onKeyDown={e => {
            if (e.key == 'Enter' && typeof onEnter == 'function') {
              onEnter();
            }
          }}
        />
        <img className="w-8 -ml-10 z-20" src={SearchIcon} />
      </div>
    </div>
  );
};

export default MBTableSearchBox;
